/**
 * @generated SignedSource<<9307e9f95e8c78bd440c81d2698d5850>>
 * @relayHash 054b277f59f52ab3975e718bd8675f5b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 13a31a15254e1fa836fd63fd2ceed4a4db3667506bd24eaf3ab068d59c80452f

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type notificationTabsQuery$variables = {
  cloudId: string;
  notificationActionType?: string | null | undefined;
  notificationType?: string | null | undefined;
  projectId?: AGG$Long | null | undefined;
};
export type notificationTabsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"notificationTable_spaAppsServicedeskNotificationLogs_NotificationLogsTable">;
};
export type notificationTabsQuery = {
  response: notificationTabsQuery$data;
  variables: notificationTabsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "notificationActionType"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "notificationType"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "notificationTabsQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "notificationTable_spaAppsServicedeskNotificationLogs_NotificationLogsTable"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "notificationTabsQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          }
        ],
        "concreteType": "AquaOutgoingEmailLogsQueryApi",
        "kind": "LinkedField",
        "name": "aquaOutgoingEmailLogs",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "notificationActionType",
                "variableName": "notificationActionType"
              },
              {
                "kind": "Variable",
                "name": "notificationType",
                "variableName": "notificationType"
              },
              {
                "kind": "Variable",
                "name": "projectId",
                "variableName": "projectId"
              }
            ],
            "kind": "LinkedField",
            "name": "GetNotificationLogs",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": (v5/*: any*/),
                    "concreteType": "AquaOutgoingEmailLogConnection",
                    "kind": "LinkedField",
                    "name": "logs",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "AquaOutgoingEmailLogItemEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "AquaOutgoingEmailLogItem",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "AquaIssueContext",
                                "kind": "LinkedField",
                                "name": "issueContext",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssue",
                                    "kind": "LinkedField",
                                    "name": "issue",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "key"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "webUrl"
                                      },
                                      (v6/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "notificationActionType"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "actionTimestamp"
                              },
                              {
                                "concreteType": "AquaNotificationDetails",
                                "kind": "LinkedField",
                                "name": "notificationDetails",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "errorKey"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "mailboxMessage"
                                  }
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "name": "recipient",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "email"
                                      }
                                    ],
                                    "type": "AtlassianAccountUser"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "name"
                                      }
                                    ],
                                    "type": "CustomerUser"
                                  },
                                  (v6/*: any*/)
                                ]
                              },
                              (v4/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "cursor"
                          }
                        ]
                      },
                      {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "startCursor"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "endCursor"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "hasPreviousPage"
                          }
                        ]
                      }
                    ],
                    "storageKey": "logs(first:20)"
                  },
                  {
                    "args": (v5/*: any*/),
                    "handle": "connection",
                    "key": "aquaOutgoingEmail__logs",
                    "kind": "LinkedHandle",
                    "name": "logs"
                  }
                ],
                "type": "AquaOutgoingEmailLog"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "identifier"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "message"
                  }
                ],
                "type": "QueryError"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v6/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "13a31a15254e1fa836fd63fd2ceed4a4db3667506bd24eaf3ab068d59c80452f",
    "metadata": {},
    "name": "notificationTabsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6f7dc50ebd258f4d9825a9fe7ca9f93f";

export default node;
